import { useState, FC } from 'react';
import intl from 'react-intl-universal';
import { Button } from '@getsynapse/design-system';
import { useAppThunkDispatch } from 'state/store';
import { changeLdUserToBusiness } from 'state/UsersManagement/usersManagementSlice';
import { showNotification } from 'state/SnackbarNotification/SnackbarNotificationSlice';
import ChangeTypeModal from './ChangeTypeModal';

interface ChangeLdUserToBusinessProps {
  userId: string;
}

const ChangeLdUserToBusiness: FC<ChangeLdUserToBusinessProps> = ({
  userId,
}) => {
  const [showChangeTypeModal, setShowChangeTypeModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useAppThunkDispatch();

  const toggleChangeTypeModal = () => {
    setShowChangeTypeModal(!showChangeTypeModal);
  };

  const handleSubmit = async (newBusinessUnit: string) => {
    setIsSubmitting(true);
    try {
      await dispatch(
        changeLdUserToBusiness({ userId, businessTeamId: newBusinessUnit })
      ).unwrap();
      dispatch(
        showNotification({
          notificationVariant: 'success',
          notificationTitle: intl.get(
            'SETTINGS_PAGE.USER_PAGE.CHANGE_LD_USER_TO_BUSINESS.MODAL.NOTIFICATIONS.SUCCESS'
          ),
        })
      );
    } catch {
      dispatch(
        showNotification({
          notificationVariant: 'error',
          notificationTitle: intl.get(
            'SETTINGS_PAGE.USER_PAGE.CHANGE_LD_USER_TO_BUSINESS.MODAL.NOTIFICATIONS.ERROR.TITLE'
          ),
          notificationMessage: intl.get(
            'SETTINGS_PAGE.USER_PAGE.CHANGE_LD_USER_TO_BUSINESS.MODAL.NOTIFICATIONS.ERROR.BODY'
          ),
        })
      );
    } finally {
      setIsSubmitting(false);
      setShowChangeTypeModal(false);
    }
  };

  return (
    <>
      <div className='pl-6 flex items-end'>
        <Button variant='secondary' onClick={toggleChangeTypeModal}>
          {intl.get(
            'SETTINGS_PAGE.USER_PAGE.CHANGE_LD_USER_TO_BUSINESS.TRIGGER_BUTTON'
          )}
        </Button>
      </div>
      <ChangeTypeModal
        isOpen={showChangeTypeModal}
        onClose={toggleChangeTypeModal}
        onSubmit={handleSubmit}
        isLoading={isSubmitting}
      />
    </>
  );
};

export default ChangeLdUserToBusiness;
